<template>

    <div id="processors">

        <div class="flex">
            <div class="flex-1 mb-4">
                <h1 class="text-2xl font-medium text-gray-900 capitalize">Edit Processor</h1>
            </div>

            <div class="flex mb-4 justify-end"></div>
        </div>

        <div class="flex flex-col"  v-if="loaded">

            <ul class="top-help-block">
                <li><span class="text-brand-600">*</span> denotes required field</li>
            </ul>

            <form action="#" method="POST" @submit.prevent="form.updateProcessor(form.data.id)">

                <div class="panel">

                    <div class="panel-form">
                        <div class="panel-title">
                            <h3>Processor</h3>
                            <p>
                                Update a Processor for integrations and product synchronisation.
                            </p>
                        </div>
                        <div class="panel-section">
                            <div class="grid grid-cols-6 gap-6">

                                <div class="form-control col-span-6 xl:col-span-4" :class="{ 'form-control-error': form.fieldHasErrors('id') }">
                                    <label for="processor_id" class="block text-sm font-medium text-gray-700">Processor ID</label>
                                    <input type="text" name="id" id="processor_id" v-model="form.data.id" :disabled="true">
                                </div>

                                <div class="form-control col-span-6 xl:col-span-4" :class="{ 'form-control-error': form.fieldHasErrors('driver') }">
                                    <label for="processor_driver" class="block text-sm font-medium text-gray-700">Driver<i></i></label>
                                    <select name="driver" id="processor_driver" v-model="form.data.driver">
                                        <option :value="null">Select Driver</option>
                                        <option :value="driver.value" v-for="driver in form.drivers.data">{{ driver.name }}</option>
                                    </select>
                                    <span v-if="form.fieldHasErrors('driver')">{{ form.getFieldError('driver') }}</span>
                                </div>

                                <div class="form-control col-span-6 xl:col-span-4" :class="{ 'form-control-error': form.fieldHasErrors('endpoint') }">
                                    <label for="processor_endpoint" class="block text-sm font-medium text-gray-700">Endpoint<i></i></label>
                                    <input type="text" name="endpoint" id="processor_endpoint" v-model="form.data.endpoint">
                                    <span v-if="form.fieldHasErrors('endpoint')">{{ form.getFieldError('endpoint') }}</span>
                                </div>
                                   
                                <div class="form-control col-span-6 xl:col-span-4" :class="{ 'form-control-error': form.fieldHasErrors('processor_view_order_url') }">
                                    <label for="processor_view_order_url" class="block text-sm font-medium text-gray-700">View Order URL</label>
                                    <input type="text" name="view_order_url" id="processor_view_order_url" v-model="form.data.view_order_url">
                                    <span v-if="form.fieldHasErrors('processor_view_order_url')">{{ form.getFieldError('processor_view_order_url') }}</span>
                                </div>

                                <div class="form-control col-span-6 xl:col-span-4" :class="{ 'form-control-error': form.fieldHasErrors('token') }">
                                    <label for="processor_token" class="block text-sm font-medium text-gray-700">Token</label>
                                    <textarea name="token" id="processor_token" v-model="form.data.token"></textarea>
                                    <span v-if="form.fieldHasErrors('token')">{{ form.getFieldError('token') }}</span>
                                </div>

                                <div class="form-control col-span-6 xl:col-span-4" :class="{ 'form-control-error': form.fieldHasErrors('signature') }">
                                    <label for="processor_signature" class="block text-sm font-medium text-gray-700">Signature</label>
                                    <input type="text" name="signature" id="processor_signature" v-model="form.data.signature">
                                    <span v-if="form.fieldHasErrors('signature')">{{ form.getFieldError('signature') }}</span>
                                </div>

                                <div class="form-control col-span-6 xl:col-span-4" :class="{ 'form-control-error': form.fieldHasErrors('tenant') }">
                                    <label for="processor_tenant_name" class="block text-sm font-medium text-gray-700">Tenant<i></i></label>
                                    <select name="tenant_name" id="processor_tenant_name" v-model="form.data.tenant_name">
                                        <option :value="null">Select Tenant</option>
                                        <option :value="tenant.name" v-for="tenant in form.tenants.data">{{ tenant.name }}</option>
                                    </select>
                                    <span v-if="form.fieldHasErrors('tenant')">{{ form.getFieldError('tenant') }}</span>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

                <div class="flex mt-6 justify-end">

                    <div class="flex border-l-4 border-brand-500 bg-white text-gray-700 px-4 py-1 rounded tracking-wide shadow items-center text-brand-400" v-if="form.successful()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                        </svg>
                        <p class="text-gray-700 text-sm" v-html="form.getSuccessMessage()"></p>
                    </div>

                    <div class="flex border-l-4 border-error-500 bg-error-50 text-gray-700 px-4 py-1 rounded tracking-wide shadow items-center text-error-400" v-if="form.hasError()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        <p class="text-error-500 text-sm" v-html="form.getErrorMessage()"></p>
                    </div>

                    <button type="submit" class="btn-outline justify-center px-6 ml-6" @click.prevent="goBack">
                        Go Back
                    </button>

                    <button type="submit" class="btn justify-center px-6 ml-6" :disabled="form.isFormUpdating()">
                        <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" v-if="form.isFormUpdating()">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Update Processor
                    </button>
                </div>
            </form>

        </div>
        <Loading message="Loading Processors" v-else></Loading>

    </div>

</template>

<script>
import Loading from "../Support/Loading";
import {Processor} from "../../app/Procesor/Processor";
import {NavigationMixin, PermissionMixin} from "../../support/mixins";

export default {
    name: "Processors",
    mixins: [PermissionMixin, NavigationMixin],
    data() {
        return {
            processor: false,
            form: null,
            loaded: false,
        }
    },
    components: {
        Loading
    },
    mounted() {
        let vm = this;
        vm.processor = this.$router.currentRoute.params.processor;

        new Promise(resolve => {
            vm.form = new Processor();

            vm.form.edit(vm.processor).then(response => {
                resolve(true);
            }).catch(error => vm.handleError(error));
        }).then(result => {
            vm.loaded = result;
        });
    }
}
</script>


